import React, { useEffect, useState } from 'react';
import { auth } from '../../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { useLocation } from 'react-router-dom';

function Error() {
  const [status, setStatus] = useState('checking');
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const oobCode = searchParams.get('oobCode');
  const marquess = ['Email verification']; // Replace with your actual array
  const AllMarquess = Array(8).fill(marquess).flat();

  useEffect(() => {
    // console.log('Verification process started');
    // console.log('oobCode present:', !!oobCode);
    // console.log('Full URL:', window.location.href);

    let intervalId;

    // Set up auth state listener
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // console.log('User found, starting verification check');
        // Start polling for verification status
        intervalId = setInterval(async () => {
          // console.log('Checking verification status...');
          // Force refresh the user to get latest verification status
          await user.reload();
          if (user.emailVerified) {
            // console.log('Email verified!');
            setStatus('verified');
            // Clear the interval once verified
            clearInterval(intervalId);
          } else {
            // console.log('Email not yet verified');
          }
        }, 2000); // Check every 2 seconds
      } else {
        // console.log('No user found');
        setStatus('not-verified');
      }
    });

    // Cleanup function
    return () => {
      if (intervalId) {
        // console.log('Cleaning up verification polling');
        clearInterval(intervalId);
      }
      unsubscribe();
    };
  }, []);

  const getMessage = () => {
    // console.log('Current verification status:', status);
    switch (status) {
      case 'verified':
        return {
          title: '✔',
          message: 'Your email has been successfully verified. You can now close this tab and return to your original tab.'
        };
      case 'not-verified':
        return {
          title: '✗',
          message: 'Email verification failed. Please try again or contact support.'
        };
      default:
        return {
          title: '↺',
          message: 'Verifying your email...'
        };
    }
  };

  const { title, message } = getMessage();

  return (
    <section className="page-error section-padding valign">
      <div className="container">
        <div className="text-center">
          <h1>{title}</h1>
          <p>{message}</p>
          {status === 'not-verified' && (
            <a
              href="/brands/new"
              className="butn butn-md butn-bg main-colorbg radius-30 mt-30"
            >
              <span className="text">Try Again</span>
            </a>
          )}
        </div>
      </div>
      <div className="marq">
        <div className="main-marq">
          <div className="slide-har st1 strok">
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="marq">
        <div className="main-marq">
          <div className="slide-har st2 non-strok">
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="marq">
        <div className="main-marq">
          <div className="slide-har st1 strok">
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="marq">
        <div className="main-marq">
          <div className="slide-har st2 non-strok">
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4 className="d-flex align-items-center">
                    <span>{item}</span>
                    <span className="ml-40">
                      <i className={`fas ${
                        status === 'verified' 
                          ? 'fa-check-circle' 
                          : status === 'not-verified' 
                            ? 'fa-times-circle' 
                            : 'fa-spinner fa-spin'
                      }`}></i>
                    </span>
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Error;
